export const validation = {
  titleMaxChar: 50,
  paragraphMaxChar: 150,
  title: { required: true },
  blocks: {
    min: 1,
    max: 2
  }
}
